import React from 'react';
import ReactDOM from 'react-dom/client';
import Root from "./Root";
import {initPushNotificationService} from "./lib/pushNotification/PushNotificationService";
import './i18n'
import 'material-symbols'

import translations from './i18n/de'

function urlB64ToUint8Array(base64String: string) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

// RISKS.md/P0.5: the VAPID public key, safe to commit; its private half is the server's VAPID_PRIVATE_KEY.
const vapidPublicKey =
    (window as any)._env_?.REACT_APP_VAPID_PUBLIC_KEY ||
    import.meta.env.REACT_APP_VAPID_PUBLIC_KEY ||
    'BJCh6JGKABxd4QogYbRztN8C12O8RZ0q4esDJwVWa0lhKcGCI1U5_P6AMTb9q37o-qHkO7_nuOug6oYRtigHoc0'
initPushNotificationService(vapidPublicKey)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

root.render(<Root/>);
